import { useEffect, useState } from "react";
import { BarChart3, FileSpreadsheet } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

const TICK = { fontSize: 11, fill: "#94a3b8" };
const TOOLTIP_STYLE = { background: "#0f172a", border: "1px solid #334155", fontSize: 12 };
const shortDay = (d) => d.slice(8, 10) + "/" + d.slice(5, 7);

export function PartnerStats({ partnerId }) {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.partnerStats(partnerId, days).then(setData).catch(() => setData([])); }, [partnerId, days]);
  const tot = (data || []).reduce((a, r) => ({ plays: a.plays + r.plays, wins: a.wins + r.wins, redeemed: a.redeemed + r.redeemed }), { plays: 0, wins: 0, redeemed: 0 });
  return (
    <div className="w-full rounded-lg bg-secondary/40 p-3 space-y-2 text-xs" data-testid={`partner-stats-${partnerId}`}>
      <div className="flex flex-wrap items-center gap-2">
        <p className="font-semibold flex items-center gap-1.5 flex-1"><BarChart3 className="h-3.5 w-3.5" /> Giocate e vincite per giorno
          <span className="font-normal text-muted-foreground" data-testid={`partner-stats-totals-${partnerId}`}>· {tot.plays} giocate · {tot.wins} vincite · {tot.redeemed} ritirati</span></p>
        {[7, 30, 90].map((n) => <button key={n} type="button" onClick={() => setDays(n)} className={`rounded-full border px-2.5 py-1 ${days === n ? "border-primary bg-primary/10" : "border-border"}`} data-testid={`partner-stats-days-${n}-${partnerId}`}>{n} gg</button>)}
        <a href={api.partnerStatsXlsxUrl(partnerId, days)} data-testid={`partner-stats-xlsx-${partnerId}`}><Button size="sm" variant="outline" className="h-8 text-xs gap-1 border-border"><FileSpreadsheet className="h-3.5 w-3.5" /> Esporta Excel</Button></a>
      </div>
      <div className="h-44">
        {data && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" opacity={0.3} />
              <XAxis dataKey="date" tickFormatter={shortDay} tick={TICK} interval="preserveStartEnd" />
              <YAxis allowDecimals={false} tick={TICK} />
              <Tooltip contentStyle={TOOLTIP_STYLE} labelFormatter={(d) => new Date(d).toLocaleDateString("it-IT")} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="plays" name="Giocate" fill="#3b82f6" radius={[3, 3, 0, 0]} />
              <Bar dataKey="wins" name="Vincite" fill="#059669" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
